var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.792019 7.98206L1.64905 7.12503C1.81632 6.95776 2.08794 6.95776 2.2552 7.12503L6.23779 11.1076L17.0774 0.268026C17.2447 0.100762 17.5163 0.100762 17.6835 0.268026L18.5406 1.12506C18.7078 1.29232 18.7078 1.56394 18.5406 1.7312L6.54124 13.7305C6.37398 13.8978 6.10236 13.8978 5.9351 13.7305L0.792019 8.5882C0.624015 8.42094 0.624015 8.14932 0.792019 7.98206Z",
    fill: "#302C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.34343d326f56121b11ef75dd4430f7d0.svg";
export { ForwardRef as ReactComponent };